import { Box, Typography } from '@mui/material';
import React from 'react';
import { useAlertUiTranslation } from '../../../../hooks';
import { NotificationContentSectionWrapper } from '../NotificationContentSectionWrapper';
export const NotificationPhinDetails = ({ additionalData }) => {
    const { t } = useAlertUiTranslation();
    if (!(additionalData === null || additionalData === void 0 ? void 0 : additionalData.phinMessageType)) {
        return null;
    }
    return (React.createElement(NotificationContentSectionWrapper, { heading: t('phin.common.phinDetails') },
        React.createElement(Box, { sx: { display: 'grid', gridTemplateColumns: 'max-content auto', alignItems: 'center', columnGap: 10, rowGap: 0.5 } },
            React.createElement(NotificationPhinDetail, { title: t('phin.common.uniqueIdentifier'), value: additionalData.phinUniqueIdentifier }),
            React.createElement(NotificationPhinDetail, { title: t('phin.common.messageType'), value: toTitleCase(additionalData.phinMessageType) }),
            React.createElement(NotificationPhinDetail, { title: t('phin.common.urgencyOfEvent'), value: toTitleCase(additionalData.phinUrgencyOfEvent) }),
            React.createElement(NotificationPhinDetail, { title: t('phin.common.severityOfEvent'), value: toTitleCase(additionalData.phinSeverityOfEvent) }),
            React.createElement(NotificationPhinDetail, { title: t('phin.common.certaintyOfEvent'), value: toTitleCase(additionalData.phinCertaintyOfEvent) }),
            React.createElement(NotificationPhinDetail, { title: t('phin.common.acknowledgeMessage'), value: booleanToString(additionalData.phinRecipientAcknowledge) }),
            React.createElement(NotificationPhinDetail, { title: t('phin.common.deliveryTime'), value: additionalData.phinDeliveryTimeInMinutes }))));
};
const NotificationPhinDetail = ({ title, value }) => {
    if (!value) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Typography, { variant: 'subtitle2' }, title),
        React.createElement(Typography, { variant: 'body2' }, value)));
};
function booleanToString(value) {
    if (!value) {
        return undefined;
    }
    return value === 'true' ? 'Yes' : 'No';
}
function toTitleCase(str) {
    if (!str) {
        return;
    }
    else if (str.trim() === '') {
        return str;
    }
    return str[0].toUpperCase() + str.slice(1);
}
